import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/ContextData';
import DemoModal from '../../components/modals/DemoModal';
import ComplaintModal from '../../components/modals/ComplaintModal';
import DealerConnectModal from '../../components/modals/DealerConnectModal';

const Footer = () => {
    const { demo, dealerId, setDealerId } = useAuth()
    const navigate = useNavigate();
    const [showComModal, setShowComModal] = useState(false);
    const [delaerShow, setDelaerShow] = useState(false);
    const [demoToast, setDemoToast] = useState(false);
    const [delearData, setDelearData] = useState("");

    const cate = [
        {
            name: 'Wallpapers',
        },
        {
            name: 'PVC Panel',
        },
        {
            name: 'Grass',
        },
        {
            name: 'Flooring',
        },
        {
            name: 'Ceiling',
        },
        {
            name: 'Vertical Garden',
        },
        {
            name: '3D Foam Panel',
        },
    ]
    const pathname = window.location.pathname;

    useEffect(() => {
        if (dealerId && dealerId.length === 10) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "dealerId": dealerId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/about", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setDelearData({
                            email: result.data.email,
                            mobile: result.data.mobile,
                            address: result.data.street + ", " + result.data.city + ", " + result.data.state + " - " + result.data.pincode,
                        });
                        if (!localStorage.getItem("dealerId")) {
                            setDealerId(result.data.dealerId)
                            localStorage.setItem("dealerId", result.data.dealerId)
                            localStorage.setItem("storeName", result.data.storeName)
                            navigate(pathname)
                        }
                    }
                })
                .catch(error => console.log('error', error));
        }
    }, [dealerId, setDealerId, navigate, pathname]);
    // const origin = window.location.origin
    return (
        <React.Fragment>
            <ComplaintModal
                show={showComModal}
                closeModal={setShowComModal}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />
            <div className="bg-dark wm text-white cp">
                <Row className="mx-0 pt-5">
                    <Col className="pe-5">
                        <Link to="/" className="text-white">
                            <img src={"/assets/images/wallicon_white_logo.png"} alt="Wallicon" height={65} />
                            <p className="mt-4">
                                An Interior Tech Company
                            </p>
                        </Link>
                    </Col>
                    <Col >
                        <h5 className="mb-4 cpm">Categories</h5>
                        {cate.map((item, index) =>
                            <p
                                key={index}
                                className="mouse"
                            // onClick={() => {
                            //     navigate();
                            // }}
                            >
                                <Link to={"/" + item.name.toLowerCase().replace(/\s/g, '-') + (dealerId && "?dealerId=" + dealerId)} className="text-white">
                                    {item.name}
                                </Link>
                            </p>
                        )}
                    </Col>
                    <Col >
                        <h5 className="mb-4 cpm">Quick Links</h5>
                        <p className="text-white mouse" onClick={() => {
                            if (demo) {
                                setDemoToast(true)
                            } else if (!dealerId) {
                                setDelaerShow(true)
                            } else {
                                navigate("/about" + (dealerId && "?dealerId=" + dealerId))
                            }
                        }}>
                            About Us
                        </p>
                        <div className="mb-3"><Link to="/careers" className="text-white">Careers</Link></div>

                        <div className="text-white mouse mb-3" onClick={() => setShowComModal(true)}>
                            Drop A Complaint
                        </div>
                        <p >
                            <Link to='/terms' className="text-white text-decoration-none">Terms &amp; Conditions</Link>
                        </p>
                        <p >
                            <Link to='/privacy' className="text-white text-decoration-none">Privacy &amp; Policy</Link>
                        </p>
                        <p >
                            <Link to='/' className="text-white text-decoration-none">Project Gallery</Link>
                        </p>
                    </Col>
                    <Col >
                        <h5 className="mb-4 cpm">Follow Us On</h5>
                        <a href="https://www.instagram.com/wallicon_official/" target="_blank" rel="noreferrer">
                            <img src="/assets/icons/instagram.png" alt="Instagram" height={25} />
                        </a>
                        <a href="https://twitter.com/wallicon2022" target="_blank" rel="noreferrer">
                            <img src="/assets/icons/twitter.png" alt="Twitter" height={25} className="mx-4" />
                        </a>
                        <a href="https://www.facebook.com/wallicon2022/" target="_blank" rel="noreferrer">
                            <img src="/assets/icons/fb.png" alt="Facebook" height={25} />
                        </a>
                        {delearData &&
                            <>
                                <p className='my-3'>
                                    Email: <a href={"mailto:" + delearData.email} className="text-white">{delearData.email}</a>
                                </p>
                                <p className='mb-3'>
                                    Phone: <a href={"tel:" + delearData.mobile} className="text-white">+91-{delearData.mobile}</a>
                                </p>
                                <p>
                                    Address: {delearData.address}
                                </p>
                            </>
                        }
                    </Col>
                    <Col sm={12}>
                        <p>&copy; {new Date().getFullYear()} <Link className="text-white" to="/">Wallicon Private Limited.</Link> All Rights Reserved.</p>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Footer
